// extracted by mini-css-extract-plugin
export default {"container":"hastaPublicaResumo_container__RV9Ol","totais":"hastaPublicaResumo_totais__ZkoMe"};